// src/features/records/components/MapView/components/MapControls.js
import { Navigation } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import styles from './MapControls.module.css';

const MapControls = ({ onGeolocationClick, hasUserLocation, isLocationCentered, className }) => {
  const { t } = useTranslation();
  const controlLabel = hasUserLocation
    ? t('records.views.map.controls.go_to_my_location')
    : t('records.views.map.controls.location_unavailable');

  return (
    <div className={`${styles.controlsContainer} ${className || ''}`}>
      <button
        className={`${styles.geolocationButton} ${isLocationCentered ? styles.active : ''}`}
        onClick={onGeolocationClick}
        disabled={!hasUserLocation}
        title={controlLabel}
        aria-label={controlLabel}
      >
        <Navigation className={styles.icon} />
      </button>
    </div>
  );
};

export default MapControls;
